// extracted by mini-css-extract-plugin
module.exports = {"simpleheadline":"SimpleModernHeadline-module--simpleheadline--1S2Hm","center":"SimpleModernHeadline-module--center--3gOUr"};